import { render, staticRenderFns } from "./planDetailDc.vue?vue&type=template&id=d6133dc8&scoped=true"
import script from "./planDetailDc.vue?vue&type=script&lang=js"
export * from "./planDetailDc.vue?vue&type=script&lang=js"
import style0 from "./planDetailDc.vue?vue&type=style&index=0&id=d6133dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6133dc8",
  null
  
)

export default component.exports